import axios from '@/services/ProductService/productInstance'


export default async function deleteProductProfile(id: string) {
	try {
		const res = await axios.delete(`/productProfiles/${id}`)
		return res.data
	} catch {
		return null
	}
}